import { render, staticRenderFns } from "./popdrop.vue?vue&type=template&id=32e42f88&scoped=true"
import script from "./popdrop.vue?vue&type=script&lang=js"
export * from "./popdrop.vue?vue&type=script&lang=js"
import style0 from "./popdrop.vue?vue&type=style&index=0&id=32e42f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e42f88",
  null
  
)

export default component.exports